<h2 class="video-title sir-text-style-title-m-default">Watch example videos</h2>
<p class="video-description sir-text-style-paragraph-l-default">
  Here are some examples of how similar companies automated their processes. See how they achieved
  their goals, improved productivity, and addressed challenges just like yours.
</p>

@if (cardItems()) {
  <sirius-media-slider
    [items]="cardItems()"
    [type]="'small'"
    [showDescription]="true">
  </sirius-media-slider>
}
